var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleBackslash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0159 2H11.9999C9.34778 1.99788 6.8034 3.04942 4.92654 4.92328C3.04967 6.79714 1.99407 9.33984 1.99195 11.992C1.98982 14.6442 3.04136 17.1886 4.91522 19.0654C6.78909 20.9423 9.33178 21.9979 11.9839 22H11.9999C14.6521 22.002 17.1964 20.9503 19.0732 19.0764C20.95 17.2024 22.0055 14.6597 22.0074 12.0075C22.0094 9.35534 20.9578 6.81101 19.0838 4.93424C17.2099 3.05747 14.6671 2.00199 12.0149 2H12.0159ZM11.9999 4H12.0119C13.7876 4.00455 15.5107 4.60297 16.9069 5.7L5.67795 16.891C4.76095 15.7091 4.19409 14.2935 4.04185 12.8053C3.88962 11.3171 4.15812 9.81609 4.81681 8.47297C5.47551 7.12985 6.49795 5.99856 7.76782 5.20781C9.03769 4.41705 10.504 3.99858 11.9999 4V4ZM17.6469 17.665C16.9066 18.4079 16.0263 18.9967 15.0571 19.3975C14.0878 19.7983 13.0488 20.0031 11.9999 20H11.9869C10.2103 20.0002 8.48491 19.4045 7.08695 18.308L18.3159 7.108C19.5124 8.64546 20.1046 10.5677 19.9808 12.5119C19.857 14.4561 19.0257 16.2877 17.6439 17.661L17.6469 17.665Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleBackslash);
export default __webpack_public_path__ + "static/media/circle-backslash.79212c5a83602004c69633e0fa274ed6.svg";
export { ForwardRef as ReactComponent };